import { render, staticRenderFns } from "./task_step2.vue?vue&type=template&id=67c19d6c"
import script from "./task_step2.vue?vue&type=script&lang=js"
export * from "./task_step2.vue?vue&type=script&lang=js"
import style0 from "./task_step2.vue?vue&type=style&index=0&id=67c19d6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports